import { colors } from '@core/helpers'
import { type IconProps } from '@core/types/components'

export const VisibilityOffIcon = ({ className, color = colors.primary, size = 24 }: IconProps) => {
  return (
    <i className={className}>
      <svg xmlns='http://www.w3.org/2000/svg' height={size} viewBox='0 -960 960 960' width={size}>
        <path
          fill={color}
          d='m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z'
        />
      </svg>
    </i>
  )
}
